import { createContext, FC, RefObject, useState } from 'react';

interface TabBarData {
  tabBarHeight: number;
  handleTabBarHeight: (ref: RefObject<HTMLDivElement>) => void;
}

export const TabBarContext = createContext<TabBarData>(null as any);

export const TabBarContextProvider: FC = ({ children }) => {
  const [tabBarHeight, setTabBarHeight] = useState(0);

  const handleTabBarHeight = (ref: RefObject<HTMLDivElement>) => {
    if (ref === null) return;
    ref.current?.clientHeight
      ? setTabBarHeight(ref.current?.clientHeight)
      : setTabBarHeight(0);
  };

  return (
    <TabBarContext.Provider
      value={{
        tabBarHeight,
        handleTabBarHeight,
      }}
    >
      {children}
    </TabBarContext.Provider>
  );
};
